import { render } from "./OrganizationSettings.vue?vue&type=template&id=7a4a6494&scoped=true"
import script from "./OrganizationSettings.vue?vue&type=script&lang=js"
export * from "./OrganizationSettings.vue?vue&type=script&lang=js"

import "@/assets/styles/organization-settings-page.css?vue&type=style&index=0&lang=css&external"
import "./OrganizationSettings.vue?vue&type=style&index=1&id=7a4a6494&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4a6494"]])

export default __exports__